import { ref, watch } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useDeductionList() {
    const toast = useToast()
    const records = ref(null)

    // Table Handler
    const columns = [
        {
            key: 'name', label: 'Name', sortable: true, thStyle: { width: '30%' }, thClass: 'text-left', tdClass: 'text-left',
        },
        {
            key: 'amount', sortable: true, thStyle: { width: '15%' }, thClass: 'text-right', tdClass: 'text-right',
        },
        {
            key: 'type_description', label: 'Type', thStyle: { width: '15%' }, thClass: 'text-left', tdClass: 'text-left',
        },
        {
            key: 'isOptional', label: 'Mandatory?', thStyle: { width: '10%' }, thClass: 'text-left', tdClass: 'text-left',
        },
        { key: 'deductibles', label: 'Applies On' },
        { key: 'actions', thClass: 'text-right', tdClass: 'text-right' },
    ]

    const from = ref(0)
    const to = ref(0)
    const meta = ref({ from: 0, to: 0, total: 0 })
    const perPage = ref(10)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [5, 10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('name')
    const isSortDirDesc = ref(true)

    const myDeductions = ref([])

    const refetch = () => {
        records.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
        refetch()
    })

    const fetch = (ctx, callback) => {
        store
            .dispatch('cromis-deductions/list', {
                query: searchQuery.value,
                per_page: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
            })
            .then(response => {
                const { deductions, meta } = response.data

                meta.value = meta

                callback(deductions)
                totalRecords.value = meta.value.total
                from.value = meta.value.from
                to.value = meta.value.to
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching banks list',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    const resolveStatusVariant = status => {
        if (status) return 'success'
        if (!status) return 'secondary'
    }

    return {
        fetch,
        columns,
        perPage,
        currentPage,
        totalRecords,
        from,
        to,
        meta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        records,
        myDeductions,

        // resolveUserRoleVariant,
        // resolveUserRoleIcon,
        resolveStatusVariant,
        refetch,

        // Extra Filters
        // roleFilter,
        // planFilter,
        // statusFilter,
    }
}
